import { registryApi, walterBIApi } from '../clients/AxiosClients'

const getInventarioById = async (id) => {
	return walterBIApi.get(`v1/ReportN/GetReportInventarioData?inventarioFlorestalId=${id}`)
}
const getAllEstrato = async () => {
	return walterBIApi.get('v1/ReportN/GetDropdown')
}

const getAllEstratoQualidade = async () => {
	return walterBIApi.get('v1/ReportN/recuperar-dropdown-inventario-de-qualidade')
}

const GetReportDropdownOrdemServico = async () => {
	return registryApi.get('v1/OrdemDeServico/GetDropdown')
}

const GetReportOrdemServico = async (id) => {
	return walterBIApi.get(`v1/ReportN/GetExecutor?ordemServicoId=${id}`)
}

const GetReportOrdemServicoCabecalho = async () => {
	return registryApi.get('v1/OrdemDeServico')
}

export const dadosParaRelatorio = async (inventarioId) => {
	return walterBIApi.get(
		`v1/InventarioFlorestalRelatorio/DadosParaRelatorio?idInventarioFlorestal=${inventarioId}`,
	)
}

export const dadosDeImaHistorico = async (inventarioId) => {
	return walterBIApi.get(
		`v1/InventarioFlorestalRelatorio/DadosDeImaHistorico?idInventarioFlorestal=${inventarioId}`,
	)
}

export const dadosDeSortimento = async (inventarioId) => {
	return walterBIApi.get(
		`v1/InventarioFlorestalRelatorio/DadosDeSortimento?idInventarioFlorestal=${inventarioId}`,
	)
}

export const gerarRelatorioInventarioFlorestalLegacy = async (data) => {
	var idioma = localStorage.getItem('idioma')
	idioma = 'ptbr' == idioma ? 'pt-br' : idioma

	return walterBIApi.post(
		`v1/InventarioFlorestalRelatorio/GerarRelatorioInventarioFlorestalLegacy?idioma=${idioma}`,
		data,
	)
}

export const gerarRelatorioBetasLegacy = async (data) => {
	var idioma = localStorage.getItem('idioma')
	idioma = 'ptbr' == idioma ? 'pt-br' : idioma

	return walterBIApi.post(
		`v1/InventarioFlorestalRelatorio/GerarRelatorioInventarioBetas?idioma=${idioma}`,
		data,
	)
}

export const gerarRelatorioCompiladoLegacy = async (data) => {
	var idioma = localStorage.getItem('idioma')
	idioma = 'ptbr' == idioma ? 'pt-br' : idioma

	return walterBIApi.post(`v1/ExportCsv/GetExportacaoResultadoExcel?idioma=${idioma}`, data)
}

export const gerarRelatorioTrabalhoDoExecutorLegacy = async (ordemDeServicoId) => {
	var idioma = localStorage.getItem('idioma')
	idioma = 'ptbr' == idioma ? 'pt-br' : idioma

	return walterBIApi.get(
		`v1/TrabalhoDoExecutorRelatorio/GerarRelatorioTrabalhoDoExecutorLegacy?idOrdemDeServico=${ordemDeServicoId}&idioma=${idioma}`,
	)
}

export const getDropdownSortimento = async () => {
	return walterBIApi.get(`v1/SortimentoExport/GetDropdownSortimento`)
}

export const exportarSortimento = async (data) => {
	return walterBIApi.post('v1/SortimentoExport/ExportarSortimento', data)
}

export {
	getAllEstrato,
	getAllEstratoQualidade,
	getInventarioById,
	GetReportDropdownOrdemServico,
	GetReportOrdemServico,
	GetReportOrdemServicoCabecalho,
}
